import { Loader2 } from 'lucide-react';

/** Shared full-page loader — used by ProtectedRoute during bootstrap and by Auth0 redirects. */
export function PageLoader({ label = 'Loading…' }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-screen flex-col items-center justify-center gap-3 bg-or-cream-50 text-or-slate-500"
    >
      <Loader2 className="h-6 w-6 animate-spin text-or-orange-500" aria-hidden />
      <span className="text-[13px] font-semibold">{label}</span>
    </div>
  );
}
